import { Box, Icon } from '@nimbus-ds/components';
import {
  ArrowsHorizontalIcon,
  BrowserIcon,
  BrowserSearchIcon,
  ClockIcon,
  DiscountCircleIcon,
  GenerativeStarsIcon,
  InfoCircleIcon,
  MobileIcon,
  ShoppingCartIcon,
  TiendanubeIcon,
  WhatsappIcon,
  ListIcon,
  TruckIcon,
  PlusCircleIcon,
  ShareIcon,
} from '@nimbus-ds/icons';
import { IconBox, useResponsive } from 'commons/components';
import PromoteIcon from '../PromoteIcon';

interface RecommendationIconProps {
  type: string;
}

const getIcon = (type: string) => {
  switch (type) {
    case 'custom_domain':
      return <BrowserIcon size="small" />;
    case 'contact_info':
      return <MobileIcon size="small" />;
    case 'whatsapp_button':
      return <WhatsappIcon size="small" />;
    case 'abandoned_carts':
      return <ShoppingCartIcon size="small" />;
    case 'first_purchase_coupon':
      return <DiscountCircleIcon size="small" />;
    case 'marketing_nube':
      return <TiendanubeIcon size="small" />;
    case 'google':
      return <PromoteIcon type="google" isPromoteGrouped />;
    case 'meta':
      return <PromoteIcon type="meta" isPromoteGrouped />;
    case 'tiktok':
      return <PromoteIcon type="tiktok" isPromoteGrouped />;
    case 'social_network_footer':
      return <ShareIcon size="small" />;
    case 'page_about_us':
      return <BrowserIcon size="small" />;
    case 'page_return_policy':
      return <ArrowsHorizontalIcon size="small" />;
    case 'seo_shop':
      return <BrowserSearchIcon size="small" />;
    case 'seo_product':
      return <GenerativeStarsIcon size="small" />;
    case 'seo_category':
      return <GenerativeStarsIcon size="small" />;
    case 'promotion_percentage_discount':
      return <DiscountCircleIcon size="small" />;
    case 'time_limited_coupon':
      return <ClockIcon size="small" />;
    case 'marketing_nube_abandoned_cart_automation':
      return <ShoppingCartIcon size="small" />;
    case 'page_how_to_buy':
      return <ListIcon size="small" />;
    case 'meta_ads':
      return <PromoteIcon type="meta" isPromoteGrouped />;
    case 'google_ads':
      return <PromoteIcon type="google" isPromoteGrouped />;
    case 'tiktok_ads':
      return <PromoteIcon type="tiktok" isPromoteGrouped />;
    case 'blog':
      return <BrowserSearchIcon size="small" />;
    case 'promotion_pay_x_get_y':
      return <DiscountCircleIcon size="small" />;
    case 'free_shipping':
      return <TruckIcon size="small" />;
    case 'cross_selling':
      return <PlusCircleIcon size="small" />;
    case 'marketing_nube_recuperate_visits_automation':
      return <TiendanubeIcon size="small" />;
    case 'marketing_nube_subscription_form':
      return <TiendanubeIcon size="small" />;
    case 'marketing_nube_loyalty_automation':
      return <TiendanubeIcon size="small" />;
    default:
      return <InfoCircleIcon size="small" />;
  }
};

export function PromoteGroupedIcon({
  type,
}: Readonly<RecommendationIconProps>) {
  const { isMobile } = useResponsive();
  const color =
    type === 'seo_product' || type === 'seo_category'
      ? 'ai-generative'
      : 'primary-textLow';
  return (
    <Box display="flex" alignItems={isMobile ? 'flex-start' : 'center'}>
      <IconBox
        backgroundColor="neutral-background"
        color="primary-textLow"
        borderRadius="2"
        height="28px"
        width="28px"
        marginRight="2"
      >
        <Icon source={getIcon(type)} color={color} />
      </IconBox>
    </Box>
  );
}
